import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

const existing = localStorage.getItem("cc_token");
if (existing) api.defaults.headers.common.Authorization = `Bearer ${existing}`;

export const setToken = (t) => {
  if (t) {
    localStorage.setItem("cc_token", t);
    api.defaults.headers.common.Authorization = `Bearer ${t}`;
  } else {
    localStorage.removeItem("cc_token");
    delete api.defaults.headers.common.Authorization;
  }
};

export const getToken = () => localStorage.getItem("cc_token");
